export enum ECountryLocale {
  UNDEFINED = 'undefined',
  CZECHIA = 'cs-CZ',
  SLOVAKIA = 'sk-SK',
  POLAND = 'pl-PL',
  GERMANY = 'de-DE',
  AUSTRIA = 'de-AT',
  HUNGARY = 'hu-HU',
  SPAIN = 'es-ES',
  PORTUGAL = 'pt-PT',
  BRITAIN = 'en-GB',
  FRANCE = 'fr-FR',
  ITALY = 'it-IT',
  NETHERLANDS = 'nl-NL',
  BELGIUM = 'fr-BE',
  CROATIA = 'hr-HR',
  SWEDEN = 'sv-SE',
  DENMARK = 'da-DK',
  FINLAND = 'fi-FI',
  GREECE = 'el-GR',
  BULGARIA = 'bg-BG',
  UKRAINE = 'uk-UA',
  SLOVENIA = 'sl-SI',
  ROMANIA = 'ro-RO',
  SWITZERLAND = 'de-CH',
  RUSSIA = 'ru-RU',
  LITHUANIA = 'lt-LT',
  IRELAND = 'en-IE',
  LATVIA = 'lv-LV',
  ESTONIA = 'et-EE',
}
